<template lang="pug">
  ods-main-navigation(
    :navigation="navigation"
    ref="navigation")
    template(slot="suites")
      suites-menu
    template(slot="isPhone-user-menu")
      user-menu.is-phone__user-menu
</template>

<script>
import { mapGetters } from 'vuex'
import UserMenu from '@/components/header/UserMenu'
import navigationConfig from '@/components/nav/config.json'

export default {
  name: 'NavContent',
  components: {
    UserMenu
  },
  watch: {
    '$i18n.locale': {
      handler (val) {
        const assignName = item => {
          this.$set(item, 'name', item.langs[this.$i18n.locale])
          if (item.children && Object.keys(item.children).length) {
            for (const key in item.children) {
              assignName(item.children[key])
            }
          }
        }
        for (const key in this.navigation) {
          assignName(this.navigation[key])
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      // Permisos
      'canSearchInvoiceSales',
      'canSearchInvoicePurchases',
      'canSearchInvoiceThird',
      'canSearchInvoiceDraft',
      'canSearchOcrDocuments',
      'canSearchAccountingClose',
      'canSearchAccountingCloseDraft',
      'canSearchPendingTasks',
      'canSearchDocumentAuditory',
      'canAdminProject',
      'canAdminUser',
      'canSearchRecadvSender',
      'canSearchRecadvReceiver',
      'canSearchOrderSender',
      'canSearchOrderReceiver',
      'canSearchDeliverySender',
      'canSearchDeliveryReceiver',
      'canSearchGenralSender',
      'canSearchGenralReceiver',
      'canAdminIndra',
      'canConsultDocumentation',
      'canAdminDocumentation',
      'canConsulStatistics',
      'canSearchCMR',
      'canViewMenu'
    ]),

    // Propiedad computada para definir la navegacion de la barra lateral segun permisos
    navigation () {
      const nav = JSON.parse(JSON.stringify(navigationConfig))
      console.log('*************** this.canViewMenu ', this.canViewMenu)
      const checkValue = arr => {
        return arr.some(e => {
          return this.$store.getters[e]
        })
      }
      const filterChildren = item => {
        if (item.children && Object.keys(item.children).length) {
          for (const child in item.children) {
            if ((item.children[child].can && !checkValue(item.children[child].can)) || (!this.canViewMenu && !this.canAdminIndra)) {
              console.log('Eliminamos menu por no tener el permiso canViewMenu')
              delete item.children[child]
            } else {
              filterChildren(item.children[child])
            }
          }
        }
      }
      for (const item in nav) {
        if ((nav[item].can && !checkValue((nav[item].can))) || (!this.canViewMenu && !this.canAdminIndra)) {
          console.log('Eliminamos menu por no tener el permiso canViewMenu')
          delete nav[item]
        } else {
          filterChildren(nav[item])
        }
      }
      return nav
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
